/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ConfigPropertyDetailContract} from './contracts/config-property-detail.contract';

@Injectable({
    providedIn: 'root'
})
export class ConfigPropertyApi {
    private httpOptions = {
        headers: new HttpHeaders({
            'accept': 'application/json',
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient) {
    }

    /**
     * Gets the config property long value by key
     * @param msContext the microservice context
     * @param configKey the config property key
     */
    getLongValue(msContext: string, configKey: string): Observable<ConfigPropertyDetailContract<number>> {
        return this.http.get<ConfigPropertyDetailContract<number>>(`${msContext}/api/configProperty/key/${configKey}/long`,
                this.httpOptions);
    }

    /**
     * Gets the config property string value by key
     * @param msContext the microservice context
     * @param configKey the config property key
     */
    getStringValue(msContext: string, configKey: string): Observable<ConfigPropertyDetailContract<string>> {
        return this.http.get<ConfigPropertyDetailContract<string>>(`${msContext}/api/configProperty/key/${configKey}/string`,
                this.httpOptions);
    }

    /**
     * Gets the config property boolean value by key
     * @param msContext the microservice context
     * @param configKey the config property key
     */
    getBooleanValue(msContext: string, configKey: string): Observable<ConfigPropertyDetailContract<boolean>> {
        return this.http.get<ConfigPropertyDetailContract<boolean>>(`${msContext}/api/configProperty/key/${configKey}/bool`,
                this.httpOptions);
    }

    /**
     * This method sets the config property value for a given key
     * @param msContext the microservice context
     * @param configKey the config property key
     * @param configValue the config value
     */
    setValue(msContext: string, configKey: string, configValue: string): Observable<void> {
        return this.http.put<void>(`${msContext}/api/configProperty/key/${configKey}/value/${configValue}`, this.httpOptions);
    }
}
